import { render, staticRenderFns } from "./playerStatus.vue?vue&type=template&id=74641df3"
import script from "./playerStatus.vue?vue&type=script&lang=js"
export * from "./playerStatus.vue?vue&type=script&lang=js"
import style0 from "./playerStatus.vue?vue&type=style&index=0&id=74641df3&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports